import styled from 'styled-components'
import { Container } from '@material-ui/core';
import { PRIMARY } from '../../shared/styles/colors';


export const Wrapper = styled(Container)`
  margin: 7px auto 59px;
  @media (min-width: 600px) {
    &.MuiContainer-root {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;


export const Title = styled.p`
  font-size: .75rem;
  font-weight: 600;
  color: #de244a;
  letter-spacing: 1.71px;
`;

export const SubTitle = styled.p`
  font-size: 1.625rem;
  margin-top: 4px;
  font-weight: 600;
  color: ${PRIMARY};
`;

export const Content = styled.section`
  white-space: pre-wrap;
  padding: 16px 0 32px;
  font-size: .875rem;
  font-weight: 300;
  color: #363636;
  border-bottom: solid 1px rgba(54, 54, 54, 0.26);
`;

export const Ask = styled.p`
  margin-bottom: 16px;
`

export const AskCongrats = styled.p`
  margin-top: 16px;
  font-size: .625rem;
  font-weight: 300;
  font-style: italic;
`

export const Footer = styled.footer`
  color: #363636;
  font-size: .875rem;
  margin-top: 32px;
  .MuiButton-root {
    color: #6f6f6f;
    font-weight: 400;
    &.selected {
      background-color: ${PRIMARY};
      color: white;
    }
  }

`;
